import '@vitejs/plugin-react/preamble'
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { AppConfigurationProvider } from './appConfigurationProvider.tsx';
import { CurrentUserProvider } from './currentUserProvider.tsx';
import { MetadataProvider } from './metadataProvider.tsx';
import { SampleSetsFromEsaf } from './sampleSetsFromEsaf.tsx';
import { SampleSetsFromSet } from './sampleSetsFromSet.tsx';
import ManageBeamline from './manageBeamline.tsx';
import ManageBeamlineHome from './manageBeamline/manageBeamlineHome.tsx';
import EditScanType from './manageBeamline/editScanType/editScanType.tsx';
import HomePage from './homePage.tsx';
import EsafHome from "./esaf/esafHome.tsx";
import SetLabels from "./esaf/setLabels.tsx";
import Set from './esaf/set/set.tsx';


const root = createRoot(document.getElementById('root')!);

// const base = import.meta.env.BASE_URL;
const base = '/';
// The above resolves to "/static/" as set in vite.config.ts,
// but we should use "/" here to match Django's server behavior.

// Note that the CurrentUserProvider does not render its given children unless the user
// is logged in (it redirects and/or shows a banner instead)
// so when we render MetadataProvider we can assume loggedIn is 'true'.

root.render(
  <StrictMode>
    <AppConfigurationProvider>
      <CurrentUserProvider>
        <MetadataProvider loggedIn={true}>
          <BrowserRouter basename={base}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/esaf/:esafSlug/" element={<SampleSetsFromEsaf />}>
                <Route index element={<EsafHome />} />
                <Route path="labels" element={<SetLabels />} />
                <Route path="set/:setSlug" element={<Set />} />
              </Route>
              <Route path="/set/:setSlug" element={<SampleSetsFromSet />}>
                <Route index element={<Set />} />
              </Route>
              <Route path="/beamline/:beamlineSlug" element={<ManageBeamline />}>
                <Route index element={<ManageBeamlineHome />} />
                <Route path="set/:setSlug" element={<Set />} />
                <Route path="scantype/:scanTypeSlug" element={<EditScanType />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </MetadataProvider>
      </CurrentUserProvider>
    </AppConfigurationProvider>
  </StrictMode>
)
